import React, { useContext as useContextCore } from 'react'
import type { TooltipPopOverProps } from '@ztechapps/webui.util'
import isEmpty from 'lodash/isEmpty'

export type ProductTooltipPopOverProviderProps = Omit<TooltipPopOverProps, 'tooltipBody'> & {
  children: React.ReactNode
  productId: string
  canEdit?: boolean
}

export type ProductTooltipPopOverContextType = {
  requiredValidator: (arg: any) => void
} & Omit<ProductTooltipPopOverProviderProps, 'children'>

const context = React.createContext<ProductTooltipPopOverContextType>({} as ProductTooltipPopOverContextType)
const CoreProvider = context.Provider

export const ProductTooltipPopOverProvider = ({
  children,
  productId,
  canEdit = true,
  placement = 'right',
  ...props
}: ProductTooltipPopOverProviderProps) => {
  const requiredValidator = (e) => {
    if (isEmpty(e)) throw new Error('Required to have a value.')
  }

  return (
    <CoreProvider
      value={{
        ...props,
        placement,
        productId,
        requiredValidator,
        canEdit,
      }}
    >
      {children}
    </CoreProvider>
  )
}

export const useProductTooltipPopOverContext = () => useContextCore(context)
